import { Link } from "react-router-dom";
import { Facebook, Twitter, Instagram, Youtube, Music2, Mail } from "lucide-react";
import { useState } from "react";
import { http, errorText } from "@/lib/api";
import { toast } from "sonner";
import { Logo } from "@/components/Header";
import { useT } from "@/lib/i18n";

export const Newsletter = () => {
  const { t } = useT();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await http.post("/newsletter", { email });
      toast.success(data.message);
      setEmail("");
    } catch (err) {
      toast.error(errorText(err.response?.data?.detail));
    } finally { setBusy(false); }
  };
  return (
    <section className="container-x py-10" data-testid="newsletter-section">
      <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <h3 className="font-display text-3xl font-extrabold text-slate-900">{t("Stay Updated")}</h3>
          <p className="text-sm text-slate-500">{t("Get the latest Cameroonian sports news straight to your inbox.")}</p>
        </div>
        <form onSubmit={submit} className="flex w-full max-w-lg items-center rounded-full border border-slate-200 bg-white p-1 pl-4 shadow-sm">
          <Mail size={18} className="text-slate-400" />
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t("Enter your email address")} data-testid="newsletter-email-input"
            className="h-11 flex-1 bg-transparent px-3 text-sm outline-none" />
          <button disabled={busy} data-testid="newsletter-subscribe-btn" className="btn-green h-11">{busy ? "…" : t("Subscribe")}</button>
        </form>
        <div className="flex items-center gap-4">
          <span className="text-sm font-semibold text-slate-700">{t("Follow Us")}</span>
          {[Facebook, Twitter, Instagram, Youtube, Music2].map((I, i) => (
            <a key={i} href="#" aria-label="social" className="text-slate-800 transition-colors hover:text-[#047857]"><I size={18} /></a>
          ))}
        </div>
      </div>
    </section>
  );
};

export const Footer = () => {
  const { t } = useT();
  return (
  <footer className="border-t border-slate-100 bg-white" data-testid="site-footer">
    <div className="container-x flex flex-col items-center justify-between gap-6 py-8 md:flex-row">
      <Logo className="h-10" />
      <nav className="flex flex-wrap justify-center gap-6 text-sm font-medium text-slate-700">
        {[["Home", "/"], ["News", "/news"], ["Athletes", "/cameroonians-abroad"], ["Videos", "/videos"], ["Live Scores", "/live-scores"], ["Competitions", "/competitions"], ["Admin", "/admin"]].map(([l, to]) => (
          <Link key={to} to={to} className="hover:text-[#047857]" data-testid={`footer-link-${l.toLowerCase().replace(" ", "-")}`}>{t(l)}</Link>
        ))}
      </nav>
      <p className="text-xs text-slate-500">© {new Date().getFullYear()} MiniSports. {t("All rights reserved.")}</p>
    </div>
  </footer>
  );
};
